import Button from "@/components/Button";
import DateSelect from "@/components/DateSelect";
import useModal from "@/hooks/useModal";
import { useQuery } from "@apollo/client";
import { Controller, useForm } from "react-hook-form";
import { ORDERS_QUERY } from "../queries";
import { DateTime } from "luxon";
import { ChangeDueDateModalProps } from "./ChangeDueDateModal";

interface TerminateModalProps extends ChangeDueDateModalProps {
  terminateAll: boolean;
  totalPeople: number | null;
}

export const TerminateModal = ({
  onDismiss,
  orders,
  terminateAll,
  totalPeople,
  onSubmit,
  loading,
  errorContent
}: TerminateModalProps) => {
  const { control, watch } = useForm();
  const headline = `Terminate People`;
  const orderIds = Object.keys(orders);
  const { data } = useQuery(ORDERS_QUERY, { variables: { ids: orderIds }, skip: !orderIds.length });
  const { close, Modal } = useModal();
  const currentDate = DateTime.now().toISO();

  const terminationDateRange = watch("terminationDate", {
    startDate: currentDate,
    endDate: currentDate
  });

  const personIds = data?.duesOrders?.nodes.map((order: any) => order.person.id) || null;
  const variables = {
    ...(!terminateAll && { personIds }),
    terminationDate: terminationDateRange.startDate
  };

  return (
    <Modal
      onClosed={onDismiss}
      action={
        <Button onClick={() => onSubmit(variables, close)} disabled={loading || !terminationDateRange.startDate}>
          Terminate {terminateAll ? totalPeople : personIds?.length} People
        </Button>
      }
      headline={headline}
      displayOverflow
    >
      {errorContent ? <div className="text-red-500 font-bold text-center mb-4">{errorContent}</div> : null}
      <p className="mb-3 text-label-large">
        Total People to be Terminated: {terminateAll ? totalPeople : personIds?.length}
      </p>
      <p className="my-3">
        Are you sure you wish to terminate these people from their PGA program? A $25 re-establishment fee will be added
        to their open dues order. If they pay their invoice, their membership will be restored automatically.
      </p>
      <p>Terminated people will be sent an email notification.</p>
      <div className="mt-6">
        <input className="mt-4 ml-1 absolute"></input>

        <Controller
          name="terminationDate"
          control={control}
          render={({ field }) => (
            <DateSelect
              label="Termination Effective Date *"
              useModal={true}
              value={terminationDateRange}
              onChange={(e) => {
                field.onChange(e);
              }}
              useSingleDate
              showFooter={false}
            />
          )}
        />
      </div>
    </Modal>
  );
};
